import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { get } from "lodash-es";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getCatalogMoldSizes } from "../../../repositories/CatalogMoldSizeRepository";
import { TableMoldSize } from "../components/TableMoldSize";
import { useCatalogMoldSizeContext } from "../context/CatalogMoldSizeContext";
type Props = {};

export const CatalogMoldSizePage = (props: Props) => {
  const { actions } = useCatalogMoldSizeContext();
  const { moldSizeId } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");

  const getCatalogMoldSizesFromAPI = async () => {
    setIsLoading(true);
    const resp = await getCatalogMoldSizes();
    if (resp.ok) {
      const moldSizes = get(resp, "data.tables[0].rows", []);
      actions.setMoldSizes(moldSizes);
    } else {
      setError(resp.message);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getCatalogMoldSizesFromAPI();
  }, []);

  return (
    <>
      <HelmetDexteel title={"Mold Sizes"} />
      <Grid container justifyContent="center" alignItems="center">
        <Grid item md={12} xs={12} style={{ margin: 0 }}>
          <Paper
            elevation={1}
            style={{
              width: "100%",
              padding: "10px 0 20px",
              borderRadius: "0.75rem",
              height: "auto",
            }}
          >
            <TableMoldSize
              moldSizeId={moldSizeId}
              isLoading={isLoading}
              getCatalogMoldSizesFromAPI={getCatalogMoldSizesFromAPI}
            />
          </Paper>
        </Grid>
      </Grid>
      <ErrorModal error={error} onHide={() => setError("")} />
    </>
  );
};
